import {Typography} from "@mui/material"
import Grid from "@mui/material/Grid"
import {Trans, useTranslation} from "react-i18next"

import {Page} from "@indebted/components/Page"

function PaymentsDisabled() {
	const {t} = useTranslation()
	return (
		<Page>
			<Grid>
				<Typography align="center" variant="h6">
					{t("customer_get.payments_disabled.title")}
				</Typography>
			</Grid>

			<Grid>
				<Typography align="center" className="amp-mask">
					<Trans i18nKey="customer_get.payments_disabled.message" />
				</Typography>
			</Grid>
		</Page>
	)
}

export {PaymentsDisabled}
